import {
  GROUP_LOCATIONS_FETCHING,
  GROUP_LOCATIONS_FAILED,
  GROUP_LOCATIONS_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GROUP_LOCATIONS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case GROUP_LOCATIONS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case GROUP_LOCATIONS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
